import { render, staticRenderFns } from "./ModuleExam.vue?vue&type=template&id=06aaa859&scoped=true"
import script from "./ModuleExam.vue?vue&type=script&lang=js"
export * from "./ModuleExam.vue?vue&type=script&lang=js"
import style0 from "./ModuleExam.vue?vue&type=style&index=0&id=06aaa859&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aaa859",
  null
  
)

export default component.exports